const MIN_SIDE = 1024;
const MAX_SIDE = 2048;
const JPEG_QUALITY = 0.85;

function resizeToConstraints(
  file: File,
  minSide: number,
  maxSide: number,
  quality: number
): Promise<File> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);

    img.onload = () => {
      URL.revokeObjectURL(url);

      let { width, height } = img;
      const shorter = Math.min(width, height);
      const longer = Math.max(width, height);

      if (shorter > minSide || longer > maxSide) {
        const scaleByShort = minSide / shorter;
        const scaleByLong = maxSide / longer;
        const scale = Math.min(scaleByShort, scaleByLong);

        if (scale < 1) {
          width = Math.round(width * scale);
          height = Math.round(height * scale);
        }
      }

      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext("2d");
      if (!ctx) {
        reject(new Error("Could not get canvas context"));
        return;
      }

      ctx.drawImage(img, 0, 0, width, height);

      canvas.toBlob(
        (blob) => {
          if (!blob) {
            reject(new Error("Could not create blob"));
            return;
          }
          const resized = new File([blob], file.name.replace(/\.\w+$/, ".jpg"), {
            type: "image/jpeg",
          });
          resolve(resized);
        },
        "image/jpeg",
        quality
      );
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Could not load image"));
    };

    img.src = url;
  });
}

export function resizeImage(file: File): Promise<File> {
  return resizeToConstraints(file, MIN_SIDE, MAX_SIDE, JPEG_QUALITY);
}

export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      // Strip data URL prefix (e.g. "data:image/jpeg;base64,")
      const base64 = result.split(",")[1];
      resolve(base64);
    };
    reader.onerror = () => reject(new Error("Could not read file"));
    reader.readAsDataURL(file);
  });
}
